const BookingWidgetConfig = {}

export {
    BookingWidgetConfig
}